// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__awq6v","col":"styles_col__2Aq6a"};